import React from 'react';
import { useLegalModal } from '../../contexts/LegalModalContext';
import { LegalSection } from '../../data/legalPages';

/** Panel sidebar altı — yasal metinler aynı global modalda açılır */
const PanelLegalLinks: React.FC = () => {
  const { openLegal } = useLegalModal();

  const btn = (label: string, section: LegalSection) => (
    <button
      type="button"
      className="panel-legal-link"
      onClick={() => openLegal(section)}
    >
      {label}
    </button>
  );

  return (
    <div className="panel-legal-links" role="navigation" aria-label="Yasal bilgiler">
      {btn('Hakkımızda', 'about')}
      <span className="panel-legal-sep" aria-hidden>·</span>
      {btn('Gizlilik', 'privacy')}
      <span className="panel-legal-sep" aria-hidden>·</span>
      {btn('Koşullar', 'terms')}
    </div>
  );
};

export default PanelLegalLinks;
